import { API_URL } from 'config';

import { makeAPICall } from 'models/api';
import {
    API as BFMCAPI,
    BFMC,
    mapAPIToBFMC,
    // sampleAPIBFMCs,
} from 'models/bfmc';

declare namespace API {
    export interface UserBFMC extends BFMCAPI.BFMC {
        user_bfmc?: string[];
    }

    export interface User {
        id: number;
        username: string;
        email: string;
        roles: string[];
        bmcs: UserBFMC[];
        first_name: string;
        last_name: string;
        is_active: boolean;
    }
}

export interface User {
    id: number;
    fullName: string;
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    roles: string[];
    BFMCs: BFMC[];
    isActive: boolean;
}

export type UpdateSelf = Omit<
    User,
    'id' | 'fullName' | 'userName' | 'email' | 'roles' | 'BFMCs' | 'isActive'
>;

const SELF_ROUTE = '/users/self';

// export const sampleUser: API.User = {
//     id: 1,
//     email: 'mock_user@novasystems.com',
//     username: 'mock_user',
//     first_name: 'Mock',
//     last_name: 'User',
//     roles: [],
//     is_active: true,
//     bfmcs: [sampleAPIBFMCs[0], sampleAPIBFMCs[1], sampleAPIBFMCs[2]],
// };

export const getSelf = makeAPICall<User, void, API.User>(
    () => ({
        url: `${API_URL}${SELF_ROUTE}`,
    }),
    ({
        id,
        email,
        first_name,
        last_name,
        roles,
        is_active,
        username,
        bmcs,
    }) => ({
        id,
        userName: username,
        fullName: `${first_name} ${last_name}`,
        firstName: first_name,
        lastName: last_name,
        email,
        roles,
        isActive: is_active,
        BFMCs: bmcs.map((x) => mapAPIToBFMC(x)),
    }),
);

export const updateSelf = makeAPICall<User, { user: UpdateSelf }, API.User>(
    (payload) => {
        const { user } = payload;
        const data = new FormData();
        data.append('first_name', user.firstName);
        data.append('last_name', user.lastName);
        return {
            url: `${API_URL}${SELF_ROUTE}`,
            contentType: null,
            requestData: {
                method: 'PUT',
                body: data,
            },
        };
    },
    ({
        id,
        email,
        first_name,
        last_name,
        roles,
        is_active,
        username,
        bmcs,
    }) => ({
        id,
        userName: username,
        fullName: `${first_name} ${last_name}`,
        firstName: first_name,
        lastName: last_name,
        email,
        roles,
        isActive: is_active,
        BFMCs: bmcs.map((x) => mapAPIToBFMC(x)),
    }),
);
